import { Swiper, SwiperSlide } from 'swiper/vue'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component('Swiper', Swiper)
  vueApp.component('SwiperSlide', SwiperSlide)
})
